import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import TheDodo from '@/components/thedodo/TheDodo';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const TheDodoPage = () => {
	return (
		<Layout pageName="thedodo" title="Calm - The Dodo">
			<TheDodo />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			coupon: 'freetrial',
			is30DayOverride: true,
		},
	);

	return {
		props: {
			initialState,
			customMainId: '#login-signup',
		},
	};
};

export default TheDodoPage;
